import { render, staticRenderFns } from "./ct-ibrcode.vue?vue&type=template&id=12b4347b&scoped=true"
import script from "./ct-ibrcode.vue?vue&type=script&lang=js"
export * from "./ct-ibrcode.vue?vue&type=script&lang=js"
import style0 from "./ct-ibrcode.vue?vue&type=style&index=0&id=12b4347b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b4347b",
  null
  
)

export default component.exports